import { render } from "./Datatable.vue?vue&type=template&id=42baddba"
import script from "./Datatable.vue?vue&type=script&lang=js"
export * from "./Datatable.vue?vue&type=script&lang=js"

import "./Datatable.vue?vue&type=style&index=0&id=42baddba&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__